import { ServiceMode } from 'generated/graphql-gateway';
export { ServiceMode };

// exclude catering
export type ExcludeLegacyServiceModes = Exclude<
  ServiceMode,
  ServiceMode.CATERING_DELIVERY | ServiceMode.CATERING_PICKUP | ServiceMode.TABLE_SERVICE
>;

export type ServiceModeStatus = {
  [key in ExcludeLegacyServiceModes]: {
    /**
     * store is available in MDM
     */
    capable: boolean;
    /**
     * store is available if store hours are within service mode availability
     * and the store supports this service mode type
     */
    available: boolean;
    /**
     * state is disabled based on flag from LD, separate from store's availability
     */
    disabled: boolean;
    /**
     * store hours are open within service mode availability
     */
    open?: boolean;
  };
};
